import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const QuestionMarkOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg width={`${size}px`} height={`${size}px`} fill="none" {...props}>
    <G clipPath="url(#a)" fill={color}>
      <Path d="M12 3.81c4.51 0 8.19 3.67 8.19 8.19s-3.67 8.19-8.19 8.19S3.81 16.51 3.81 12 7.49 3.81 12 3.81Zm0-1.7c-5.46 0-9.89 4.43-9.89 9.89 0 5.46 4.43 9.89 9.89 9.89 5.46 0 9.89-4.43 9.89-9.89 0-5.46-4.43-9.89-9.89-9.89Z" />
      <Path d="M12.6 12.8v.61c0 .21-.08.38-.23.5-.15.12-.37.18-.64.18s-.48-.06-.63-.18a.594.594 0 0 1-.23-.49v-.46c0-.39.06-.67.19-.87.13-.19.37-.38.72-.57.11-.06.28-.15.51-.26.79-.38 1.19-.84 1.19-1.38 0-.38-.13-.68-.38-.9-.26-.22-.6-.33-1.05-.33-.41 0-.69.04-.86.11-.16.08-.27.24-.32.48-.07.3-.16.5-.28.59-.12.09-.3.14-.54.14-.22 0-.39-.06-.5-.18-.11-.12-.16-.32-.16-.58v-.99c0-.29.29-.53.88-.73.58-.2 1.29-.3 2.13-.3.95 0 1.7.25 2.25.74.55.5.82 1.17.82 2.02 0 .68-.25 1.26-.75 1.75s-1.21.85-2.14 1.08l.02.02Zm-.83 1.83c.46 0 .83.11 1.11.34.28.23.42.52.42.89s-.14.66-.43.89c-.28.23-.65.35-1.11.35-.46 0-.82-.12-1.1-.35-.28-.23-.42-.53-.42-.89s.14-.67.42-.89c.28-.23.65-.34 1.11-.34Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default QuestionMarkOutlined
